import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './ui-kit-sb3.component.scss';
var UiKitSb3 = /** @class */ (function (_super) {
    tslib_1.__extends(UiKitSb3, _super);
    function UiKitSb3(element) {
        return _super.call(this, element) || this;
    }
    UiKitSb3.prototype.init = function () {
    };
    UiKitSb3.prototype.bindEvents = function () {
    };
    return UiKitSb3;
}(Base));
export { UiKitSb3 };



//////////////////
// WEBPACK FOOTER
// ./components/ui-kit-sb3/ui-kit-sb3.component.ts
// module id = 729
// module chunks = 0